<template>
  <p>this is a test page for forum.</p>
</template>

<script>
export default {
    name:'Forum'
}
</script>

<style>

</style>